module.exports = __webpack_public_path__ + "static/img/freelacer-profile-picture.5c745f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temporary/freelacer-profile-picture.png
// module id = /VaK
// module chunks = 1